import { useLocation } from "react-router-dom"
import { LandingHeaderNavigation } from "./LandingHeaderNavigation";
import { HomeHeaderNavigation } from "./HomeHeaderNavigation";
import { useAuth } from "../context/auth-context";

export const NavbarItems = ({  setShowSidebar }) => {
    const { pathname = ''} = useLocation();
    const { user }     = useAuth()

    const renderNavItems = () => {
        if (pathname.toLowerCase() !== '/landing' && !!user){
            return <HomeHeaderNavigation setShowSidebar={setShowSidebar} />
        }
        return <LandingHeaderNavigation setShowSidebar={setShowSidebar} />
    }
    return (
    <div className="w-full">
        {renderNavItems()}
    </div>
    )
}